import gql from "graphql-tag";

export const CLIENT_QUERY = gql`
  query client($userId: ID!) {
    client(id: $userId) {
      firstName
      lastName
      profilePicture
      ticketId
      hubspotPortalId
      hubspotTicketId
    }
  }
`;

export const LOGIN_AS_TOKEN_QUERY = gql`
  query loginAsTokenQuery {
    loginAsToken
  }
`;

export const CLIENT_INFORMATION_QUERY = gql`
  query clientInformationQuery($userId: ID!) {
    clientInformation(id: $userId) {
      id
      dateOfBirth
      height
      phone
      city
      occupation
      userStatus
      suburb
      gender
      profilePicture
      hubspotContactVid
      dietaryRequirement
      whatsappJid
      alternateWhatsappJid
      fitnessLevel
      weight
      desiredWeight
      desiredWeightLoss
      occupation
      company
      pregnant
      companyRole
      companySize
      hasMedicalConditions
      requiredSupport
      calculatedServingSize
      calories
      taskPauseUntil
      taskPauseNote
      fitnessLevel
      weeklyGoal
      biggestObstacle
      otherObstacleText
      highestEducation
      otherJoiningInfo
      exerciseDays {
        id
        day
      }
      user {
        id
        email
        firstName
        lastName
        username
        lastLogin
        dateJoined
        usernutritionpreferenceSet {
          id
          nutritionPreference {
            id
            title
            isPrimary
          }
        }
        usertagSet {
          id
          tag {
            id
            title
            code
          }
        }
        userProfile {
          id
          lastActive
          coachingChat {
            id
          }

          activeSubscription {
            id
            corporateChallenge {
              id
              title
            }
            coach {
              id
              firstName
              lastName
            }
          }
        }
      }
      country {
        name
        iocCode
        code
      }
    }
  }
`;

export const CLIENTS_QUERY = gql`
  query clientsQuery(
    $firstName_Icontains: String
    $lastName_Icontains: String
    $phone_Icontains: String
    $email_Icontains: String
    $hubspotContactVid_Icontains: Int
    $user_CorporateChallenges_CorporateChallengeId: ID
    $user_Subscriptions_Product_Type: String
  ) {
    clients(
      user_FirstName_Icontains: $firstName_Icontains
      user_LastName_Icontains: $lastName_Icontains
      phone_Icontains: $phone_Icontains
      user_Email_Icontains: $email_Icontains
      hubspotContactVid_Icontains: $hubspotContactVid_Icontains
      user_CorporateChallenges_CorporateChallengeId: $user_CorporateChallenges_CorporateChallengeId
      productTypeFilter: $user_Subscriptions_Product_Type
      first: 100
    ) {
      edges {
        node {
          id
          phone
          hubspotContactVid
          user {
            id
            username
            firstName
            lastName
            email
            subscriptions(active: true) {
              edges {
                node {
                  id
                  product {
                    id
                    name
                    type
                  }
                }
              }
            }
            userProfile {
              id
              profilePicture
            }
          }
        }
      }
    }
  }
`;

export const PRODUCTS_QUERY = gql`
  query productTypes {
    __type(name: "ShopifyCrmExtensionProductTypeChoices") {
      name
      enumValues {
        name
        description
      }
    }
  }
`;

export const UPDATE_PROFILE_MUTATION = gql`
  mutation updateProfile($userProfileInput: UserProfileInput!) {
    updateProfile(userProfileInput: $userProfileInput) {
      ok
    }
  }
`;

export const UPSERT_EXERCISE_DAYS_MUTATION = gql`
  mutation upsertExerciseDays($days: [String]!, $userId: ID) {
    upsertExerciseDays(days: $days, userId: $userId) {
      success
    }
  }
`;
